"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const components_1 = require("@/common/components");
const styled_1 = __importDefault(require("@emotion/styled"));
const _1 = require(".");
function default_1() {
    const cart = (0, react_redux_1.useSelector)((state) => state.cart);
    const cartHasItem = Boolean(cart.length);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(CartProductsDiv, Object.assign({ cartHasItem: cartHasItem }, { children: cart.map((product, index) => ((0, jsx_runtime_1.jsx)(_1.CartProductBar, { product: product, cartItemIndex: index }, `cart_product_bar_${product.id}_${index}`))) })), cartHasItem && (0, jsx_runtime_1.jsx)(components_1.Divider, { css: { marginBottom: '6px' } })] }));
}
exports.default = default_1;
// eslint-disable-next-line prettier/prettier
const CartProductsDiv = styled_1.default.div `
  display: grid;
  gap: 6px;
  max-height: 250px;
  padding: 6px 20px;
  padding-top: ${props => (props.cartHasItem ? '6px' : '0px')};
  margin: -6px -20px 0;
  overflow-y: auto;
`;
